import { render, staticRenderFns } from "./Revocacion.vue?vue&type=template&id=0dea5b5a&"
import script from "./Revocacion.vue?vue&type=script&lang=js&"
export * from "./Revocacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports